$(document).on('ready turbolinks:load', function() {
  var use_report_template_form_sel = '#use-report-template-form';
  if ($(use_report_template_form_sel).length == 0) {
    return;
  }

  // use-report-template-option: ルートブロック
  //   子ブロックが「追加報告」項目ブロック
  var use_report_template_options_el = $(`${use_report_template_form_sel} #use-report-template-options`);

  var set_use_report_template_options_order_id = () => {
    const use_report_template_option_title = (order_id) => `追加項目${String.fromCharCode("①".charCodeAt(0) + order_id)}の項目名`;

    use_report_template_options_el.find('.use-report-template-option').each(function(order_id) {
      $(this).find('.order-id').text(use_report_template_option_title(order_id));
      $(this).find('input[name="use_report_template_option[][order_id]"]').val(order_id);
    });
  };

  var set_remove_use_report_template_option_hander = function() {
    $(`${use_report_template_form_sel} label.remove-use-report-template-option`).on('click', function() {
      // 利用報告書の追加項目ブロック削除
      $(this).parents('.use-report-template-option').remove();
      // ordr_idを付けなおす。
      set_use_report_template_options_order_id();
    });
  };

  // 利用報告作成/編集画面に 追加報告項目行 を追加
  //   (html要素id: use_report_template_optionsの子供の後ろに行追加)
  var add_use_report_template_option = (use_report_template_id, id = null, confirmation_text = null) => {
    // use-report-template-optionの元ブロック
    const option_template_el = $(`${use_report_template_form_sel} #use-report-template-option-template .use-report-template-option`);
    // コピーしたブロックを使用。
    const option_el = option_template_el.clone();

    option_el.find('input[name="use_report_template_option[][id]"]').val(id);
    option_el.find('input[name="use_report_template_option[][use_report_template_id]"]').val(use_report_template_id);
    option_el.find('input[name="use_report_template_option[][confirmation_text]"]').val(confirmation_text);

    use_report_template_options_el.append(option_el[0]); // TODO :[0]以外にいい表現がないか調べる
  };

  // 利用報告書の追加項目ブロック作成
  for (let i = 0; i < g_use_report_template_options.length; i++) {
    const option = g_use_report_template_options[i];

    add_use_report_template_option(option.use_report_template_id, option.id, option.confirmation_text);
  }
  set_use_report_template_options_order_id();
  set_remove_use_report_template_option_hander();

  // 「項目の追加」クリック時処理
  $(`${use_report_template_form_sel} label.add-use-report-template-option`).on('click', function() {
    if ($(`${use_report_template_form_sel} #use-report-template-options .use-report-template-option`).length >= g_max_confirmations) {
      alert(`報告項目は${g_max_confirmations}項目より多くできません。`);
      return false;
    }

    add_use_report_template_option(g_use_report_template_id);
    set_use_report_template_options_order_id();
    set_remove_use_report_template_option_hander();
  });

  // 「保存する」クリック時処理
  $(`${use_report_template_form_sel}`).on('submit', function() {
    // use_report_template_optionのコピー元ブロックフォームコントロールをformパラメタとしないようdisabled
    $(`${use_report_template_form_sel} #use-report-template-option-template`).find('input').prop('disabled', true);
  });
});
